import { render, staticRenderFns } from "./EditTaxPaymentModal.vue?vue&type=template&id=6951ef02&"
import script from "./EditTaxPaymentModal.vue?vue&type=script&lang=ts&"
export * from "./EditTaxPaymentModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports